import Link from "next/link"
import { Typography } from "src/orca/components/Typography/typography"

export const JoinUsInfo = () => {
  return (
    <div className="mt-tokens-space-40 flex flex-row">
      <Typography>Don&apos;t have an account?</Typography>
      <Link
        href="https://www.processout.com/contact-us"
        target="_blank"
        className="mx-tokens-space-8"
      >
        <Typography weight="medium">Join us</Typography>
      </Link>
    </div>
  )
}
